<div class="panel-heading" style="color:#ffffff;background-color: #354D6A;" title="PROJECTS">
  <div class="page-titleheader">
    GROSS PROCEEDS MAINTENANCE
  </div>
</div>

<div style="margin-top:1.3%;">
  <div class="row"
    style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
    <div class="td-col-md-2" style="width: 20%; padding-left: 20px;" class="mobileview"></div>
    <div class="card mobileviewmain" style="width: 60%; border-style: solid;border-color: #11263f;border-width: 2px; ">
      <div class="card-header">
        <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title="STAFF MAINTENANCE">
          <div class="page-titlehead">
            GROSS PROCEEDS MAINTENANCE
          </div>
        </div>

      </div>



      <div class="card-body">
        <div tabindex="0">
          <p title="Fields marked with (*) are required."
            style="color:crimson; font-size:13px;font-style:italic;text-align:left">Fields
            marked
            with (*) are required.</p>
        </div>
        <form class="form-horizontal">
          <div>

            <div>
              <div class="form-group row">
                <label tabindex="0" title="New Gross Proceeds Amount" aria-label="New Gross Proceeds Amount"
                  class="col-md-3 form-control-label">New Gross Proceeds Amount <span class="j-color">*</span></label>
                <div class="col-md-4">

                  <input type="text" name="New Gross Proceeds Amount" tabindex="0" title="{{bbudgetamount}}"
                    aria-label="New Gross Proceeds Amount" placeholder="Enter Amount" [(ngModel)]="bbudgetamount"
                    class="form-control" maxlength="50">
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-6" style="color:crimson;" tabindex="0">
                  {{bmessage}}
                </div>

              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <div class="col-sm-3"></div>
              <div class="col-sm-6" style="white-space:nowrap">

                &nbsp;
                <button id="btnClearMD" type="submit" class="btn btn-primary btnclear button_history" tabindex="0"
                  title="Clear" aria-label="Clear" (click)="bclear()">Clear</button>
                &nbsp;
                <button id="btnSaveMD" type="submit" class="btn btn-primary btnsave button_history" tabindex="0"
                  title="Save" aria-label="Save" (click)="SaveBudget()">Save</button>
                &nbsp;

                <button id="btnCloseMD" type="submit" class="btn btn-primary btndone button_history" tabindex="0"
                  title="Close" aria-label="Close" (click)="CloseBudgetInfo()">Close</button>
              </div>
            </div>
            <br />

          </div>
        </form>
      </div>


    </div>
  </div>
</div>
